import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conference-seminars-workshops',
  templateUrl: './conference-seminars-workshops.component.html',
  styleUrls: ['./conference-seminars-workshops.component.scss']
})
export class ConferenceSeminarsWorkshopsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
